import { useQueryClient as rqUseQueryClient } from '@tanstack/react-query'

export const useQueryClient = rqUseQueryClient
